export default __webpack_public_path__ + "static/media/ic_avax_24.43583fc4.svg";